import React from "react";
import GenericSelector from "./GenericSelector";

export const BLOCKS_OPTIONS = [
  { value: "all_blocks", label: "Todos los bloques" },
  { value: "available_coupons_block", label: "1. Cupones disponibles" },
  { value: "assigned_coupons_not_sent_block", label: "2. Cupones asignados no enviados" },
  { value: "burnable_barcodes_block", label: "3. Stock de códigos de barras" },
];

export default function BlocksSelector({
  value = "",
  onChange,
  options = BLOCKS_OPTIONS,
  error = null,
  required = false,
  label = "Bloques",
}) {
  return (
    <GenericSelector
      label={label}
      value={value}
      onChange={onChange}
      options={options}
      error={error}
      required={required}
    />
  );
}
